import React from 'react';
import {
  VOD_INVENTORY_FILTER_LABELS,
  VOD_INVENTORY_FILTER_ORDER,
  type VodInventoryFilter,
} from '../vodTruth';

export type VodCandidatesFiltersProps = {
  selected: VodInventoryFilter;
  counts: Partial<Record<VodInventoryFilter, number>>;
  onSelect: (filter: VodInventoryFilter) => void;
};

const VodCandidatesFilters: React.FC<VodCandidatesFiltersProps> = ({
  selected,
  counts,
  onSelect,
}) => {
  return (
    <div className="flex flex-wrap gap-2" data-testid="vod-candidates-filters">
      {VOD_INVENTORY_FILTER_ORDER.map((filter) => {
        const isSelected = selected === filter;
        const count = counts[filter];
        const label = VOD_INVENTORY_FILTER_LABELS[filter];
        const countSuffix =
          filter !== 'all' && count != null && count > 0 ? ` (${count})` : '';
        return (
          <button
            key={filter}
            type="button"
            className={`inline-flex rounded-full border px-3 py-1.5 text-xs transition-colors ${
              isSelected
                ? 'border-primary-500 bg-primary-900/40 text-primary-100'
                : 'border-secondary-600 bg-secondary-800/60 text-secondary-200 hover:bg-secondary-800'
            }`}
            data-testid={`vod-candidates-filter-${filter}`}
            aria-pressed={isSelected}
            onClick={() => onSelect(filter)}
          >
            {label}
            {countSuffix}
          </button>
        );
      })}
    </div>
  );
};

export default VodCandidatesFilters;
